import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import PeopleCard from "./PeopleCard";
import EmptyList from "../../components/EmptyList";
import { AiOutlineArrowLeft } from "react-icons/ai";
import { Loading } from "../../utils/helpers/constants";
import RoundLoader from "../../components/loader/RoundLoader";
import { fetchPeopleYouMayKnow } from "../../actions/student.action";
import Footer from "../../components/header/Footer";

export default function PeopleHome() {
  const dispatch = useDispatch();
  const history = useHistory();

  const { profile } = useSelector(({ profileReducer }) => ({
    profile: profileReducer,
  }));

  const {
    student: { people, peopleLoading },
  } = useSelector(({ studentReducer }) => ({
    student: studentReducer,
  }));

  useEffect(() => {
    // const pageAble = { page: 0, size: 6 };
    // dispatch(fetchPeopleYouMayKnow(pageAble));
    dispatch(fetchPeopleYouMayKnow());
  }, []);

  const loadState =
    peopleLoading === Loading.FETCHING ||
    profile.userProfileLoading === Loading.FETCHING;

  console.log({ people });
  return (
    <div className="px-2  py-3">
      <AiOutlineArrowLeft
        size={25}
        // onClick={() => history.push("/dashboard/user/home")}
        onClick={() => history.goBack()}
        className="mb-5 cursor-pointer"
      />
      <div className="font-bold text-2xl font-serif compass_color">People</div>
      {loadState ? (
        <RoundLoader />
      ) : (
        <>
          {people.length === 0 ? (
            <EmptyList text={"No created community yet!"} />
          ) : (
            <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-4 gap-2 mt-3">
              {people.map((person) => {
                return (
                  <PeopleCard
                    person={person}
                    key={person.id}
                    textEllipse={"two_line"}
                    imageHeight={"h-72"}
                  />
                );
              })}
            </div>
          )}
        </>
      )}
    </div>
  );
}
